
export const glossaryTerms = [
  {
    id: 1,
    term: 'RTP (Return to Player)',
    definition: 'Процент возврата игроку — теоретический показатель, указывающий какую часть ставок слот возвращает игрокам в долгосрочной перспективе. Например, RTP 96% означает, что из 100 рублей в среднем возвращается 96.',
    category: 'Основы'
  },
  {
    id: 2,
    term: 'Вейджер (Wager)',
    definition: 'Требование по отыгрышу бонуса. Показывает, сколько раз нужно прокрутить сумму бонуса перед выводом. Например, вейджер x35 на бонус 1000₽ означает необходимость сделать ставок на 35 000₽.',
    category: 'Бонусы'
  },
  {
    id: 3,
    term: 'Фриспины (Free Spins)',
    definition: 'Бесплатные вращения в игровых автоматах. Могут быть частью бонуса или активироваться в самой игре при выпадении специальных символов.',
    category: 'Бонусы'
  },
  {
    id: 4,
    term: 'Волатильность',
    definition: 'Показатель риска слота. Высокая волатильность — редкие, но крупные выигрыши. Низкая — частые, но небольшие выплаты. Средняя — баланс между частотой и размером.',
    category: 'Слоты'
  },
  {
    id: 5,
    term: 'Джекпот',
    definition: 'Крупный выигрыш в игровом автомате. Прогрессивный джекпот накапливается от ставок всех игроков и может достигать миллионов рублей.',
    category: 'Выигрыши'
  },
  {
    id: 6,
    term: 'Wild (Дикий символ)',
    definition: 'Специальный символ в слотах, заменяющий другие символы для формирования выигрышных комбинаций. Аналог джокера в картах.',
    category: 'Слоты'
  },
  {
    id: 7,
    term: 'Scatter (Скаттер)',
    definition: 'Специальный символ, запускающий бонусные функции (обычно фриспины) при выпадении определенного количества на барабанах, независимо от позиции.',
    category: 'Слоты'
  },
  {
    id: 8,
    term: 'Кэшбэк',
    definition: 'Возврат части проигранных средств. Обычно начисляется еженедельно и составляет от 5% до 20% от суммы проигрыша.',
    category: 'Бонусы'
  },
  {
    id: 9,
    term: 'KYC (Know Your Customer)',
    definition: 'Процедура верификации личности игрока. Включает проверку документов для подтверждения возраста и личности перед выводом средств.',
    category: 'Безопасность'
  },
  {
    id: 10,
    term: 'Лимит ставок',
    definition: 'Минимальная и максимальная сумма ставки в игре. Важно учитывать при выборе слота и управлении банкроллом.',
    category: 'Основы'
  },
  {
    id: 11,
    term: 'Мегавейс (Megaways)',
    definition: 'Игровая механика с переменным количеством способов выигрыша (до 117 649). Количество символов на барабанах меняется с каждым спином.',
    category: 'Слоты'
  },
  {
    id: 12,
    term: 'Мультипликатор',
    definition: 'Множитель выигрыша. Увеличивает сумму выплаты в указанное количество раз. Может быть фиксированным или накапливаться во время бонусной игры.',
    category: 'Выигрыши'
  },
  {
    id: 13,
    term: 'Депозит',
    definition: 'Пополнение игрового счета в казино. Минимальный депозит обычно составляет от 500 до 1000 рублей.',
    category: 'Основы'
  },
  {
    id: 14,
    term: 'Бонус без депозита',
    definition: 'Бонус, который казино дает без необходимости пополнения счета. Обычно это небольшая сумма или фриспины для новых игроков.',
    category: 'Бонусы'
  },
  {
    id: 15,
    term: 'Live казино',
    definition: 'Раздел казино с играми в реальном времени с живыми дилерами. Трансляция ведется из специальных студий.',
    category: 'Игры'
  },
  {
    id: 16,
    term: 'Банкролл',
    definition: 'Сумма денег, выделенная для игры в казино. Правильное управление банкроллом — ключ к ответственной игре.',
    category: 'Основы'
  }
];

export const glossaryCategories = [
  { id: 'all', name: 'Все термины' },
  { id: 'Основы', name: 'Основы' },
  { id: 'Бонусы', name: 'Бонусы' },
  { id: 'Слоты', name: 'Слоты' },
  { id: 'Выигрыши', name: 'Выигрыши' },
  { id: 'Безопасность', name: 'Безопасность' },
  { id: 'Игры', name: 'Игры' }
];
